import React from "react";
import "./navbar.css";
import logo from "../../../assets/logo.png";
import logo_black from "../../../assets/logo black square.png";
import {
  Button,
  FormControl,
  InputLabel,
  MenuItem,
  Modal,
  Select,
  TextField,
  Typography,
} from "@material-ui/core";
import checked from "../../../assets/checked.png";
import firebase from "firebase";

export default class Navbar extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      hamburger: false,
      modal: false,
      selectedDate: "",
      email: "",
      phoneNumber: 0,
      amount: 0,
      name: "",
      currency: "INR",
      error: {},
      successModal: false,
    };
  }

  componentDidMount() {
    if (this.props.location.pathname === "/") {
      document.getElementById("navposition").style.backgroundColor = "#40ae77";
    } else if (this.props.location.pathname === "/aboutus") {
      document.getElementById("navposition").style.backgroundColor = "#166d3b";
      document.getElementById("navposition").style.backgroundImage =
        "linear-gradient(90deg, #166d3b 0%, #116240 94%)";
      document.getElementById("navposition").style.boxShadow =
        "5px 0 8px rgba(0, 0, 0, .4)";
    } else if (this.props.location.pathname === "/projects") {
      document.getElementById("navposition").style.backgroundColor = "#36C67A";
      document.getElementById("navposition").style.boxShadow =
        "5px 0 8px rgba(0, 0, 0, 0.4)";
    } else if (this.props.location.pathname.includes("/blog/")) {
      document.getElementById("navposition").style.backgroundColor = "#BEBEBE";
      document.getElementById("navposition").style.boxShadow =
        "5px 0 8px rgba(0, 0, 0, 0.4)";
    } else {
      document.getElementById("navposition").style.backgroundColor = "#308367";
    }
    window.onscroll = function () {
      myFunction();
    };
    function myFunction() {
      if (
        document.body.scrollTop > 50 ||
        document.documentElement.scrollTop > 50
      ) {
        document.getElementById("navposition").classList.add("colorchange");
      } else {
        document.getElementById("navposition").classList.remove("colorchange");
      }
    }
  }

  handlePay = () => {
    if (
      this.state.email.length > 0 &&
      this.state.email.includes("@") &&
      this.state.amount > 0 &&
      this.state.phoneNumber > 0 &&
      this.state.name.length > 0
    ) {
      var options = {
        key: "rzp_live_ANj4z95zmANrk3", // Enter the Key ID generated from the Dashboard
        amount: this.state.amount * 100, // Amount is in currency subunits. Default currency is INR. Hence, 50000 refers to 50000 paise
        currency: this.state.currency,
        name: "TheoryDev",
        description: "Make your service go smoother",
        image: logo_black,
        // order_id: "order_9A33XWu170gUtm", //This is a sample Order ID. Pass the `id` obtained in the response of Step 1
        handler: (res) => {
          firebase
            .firestore()
            .collection("payments")
            .add({
              name: this.state.name,
              phoneNumber: Number(this.state.phoneNumber),
              amount: Number(this.state.amount),
              currency: "INR",
              email: this.state.email,
              paymentID: res.razorpay_payment_id,
            })
            .then(() => {
              this.setState({
                name: "",
                phoneNumber: "",
                amount: "",
                currency: "INR",
                email: "",
                error: {},
                modal: true,
                successModal: true,
              });
            });
        },
        prefill: {
          name: this.state.name,
          email: this.state.email,
          contact: this.state.phoneNumber,
        },
        theme: {
          color: "#40AE77",
        },
      };
      this.setState({
        modal: false,
      });
      var rzp1 = new window.Razorpay(options);
      rzp1.open();
    } else {
      if (this.state.name.length === 0) {
        var error = {
          inputName: "name",
          errorMsg: "Please Enter Name",
        };
        this.setState({
          error,
        });
      } else if (
        this.state.email.length === 0 ||
        !this.state.email.includes("@")
      ) {
        var error = {
          inputName: "email",
          errorMsg: "Please Enter Email",
        };
        this.setState({
          error,
        });
      } else if (this.state.phoneNumber <= 0) {
        var error = {
          inputName: "phoneNumber",
          errorMsg: "Please Enter Phone Number",
        };
        this.setState({
          error,
        });
      } else {
        var error = {
          inputName: "amount",
          errorMsg: "Please Enter Amount to Proceed",
        };
        this.setState({
          error,
        });
      }
    }
  };

  handleChange = (e) => {
    this.setState({
      [e.target.name]: e.target.value,
    });
  };

  render() {
    return (
      <>
        <div className="navposition" id="navposition">
          <a href="/">
            <img src={logo} alt="logo" />
          </a>

          <div className="navbar">
            <div className="home fil">
              <a href="/">Home</a>
            </div>
            <div className="project fil">
              <a href="/projects">Projects</a>
            </div>
            <div className="scope fil">
              <a href="/blog">Blog</a>
            </div>
            <div className="About Us fil">
              <a href="/aboutus">About Us</a>
            </div>
            <div className="contacts fil">
              <a onClick={this.props.handleContact}>Contacts Us</a>
            </div>
            <button
              type="button"
              className="makePayment"
              onClick={() => this.setState({ modal: true, hamburger: false })}
            >
              <p>Make a payment</p>
              <i className="fas fa-credit-card"></i>
            </button>
            <div
              className={
                this.state.hamburger ? "hamburger active" : "hamburger"
              }
              onClick={() =>
                this.setState({ hamburger: !this.state.hamburger }, () => {
                  if (this.state.hamburger) {
                    document.body.style.overflowY = "hidden";
                  } else {
                    document.body.style.overflowY = "scroll";
                  }
                })
              }
            >
              <div className="line1"></div>
              <div className="line2"></div>
              <div className="line3"></div>
            </div>
          </div>
          <div
            className={this.state.hamburger ? "ham-links active" : "ham-links"}
          >
            <div className="links">
              <div className="home fil">
                <a href="/">Home</a>
              </div>
              <div className="project fil">
                <a href="/projects">Projects</a>
              </div>
              <div className="scope fil">
                <a href="/blog">Blog</a>
              </div>
              <div className="About Us fil">
                <a href="/aboutUs">About Us</a>
              </div>
              <div className="contacts fil">
                <a href="#" onClick={this.props.handleContact}>
                  Contacts
                </a>
              </div>
              <button
                type="button"
                className="makePayment"
                onClick={() => this.setState({ modal: true, hamburger: false })}
              >
                <p>Make a payment</p>
                <i className="fas fa-credit-card"></i>
              </button>
            </div>
            <div className="social-media">
              <a href="https://www.facebook.com/Theorydev7/">
                <i className="fab fa-facebook"></i>
              </a>
              <a href="https://www.instagram.com/theorydev?igshid=v0r6aik0140f">
                <i class="fab fa-instagram"></i>
              </a>
              <a href="https://www.linkedin.com/in/theory-dev-09a9201b7">
                <i class="fab fa-linkedin-in"></i>
              </a>
              <a href="https://www.twitter.com/theory_dev">
                <i class="fab fa-twitter"></i>
              </a>
              <a href="#">
                <i class="fab fa-pinterest-square"></i>
              </a>
            </div>
          </div>
        </div>
        <Modal
          open={this.state.modal}
          onClose={() =>
            this.setState({
              modal: false,
            })
          }
        >
          <div className="modal">
            <i
              className="fas fa-times"
              onClick={() =>
                this.setState({
                  modal: false,
                  successModal: false,
                })
              }
            ></i>
            {this.state.successModal ? (
              <div className="success">
                <img src={checked} alt="" />
                <h3>Payment Successful</h3>
                <p>Don't forget to check your email for confirmation.</p>
                <p className="query">
                  Any queries? Call us:
                  <a href="tel:8391076673"> +91 8391076673</a>
                </p>
              </div>
            ) : (
              <>
                <h3>Make a Payment</h3>
                <div className="inputs">
                  <TextField
                    label="Name"
                    color="primary"
                    variant="outlined"
                    className="input"
                    name="name"
                    value={this.state.name}
                    onChange={this.handleChange}
                    helperText={
                      this.state.error.inputName === "name"
                        ? this.state.error.errorMsg
                        : null
                    }
                    error={this.state.error.inputName === "name"}
                    size="small"
                  ></TextField>
                  <TextField
                    label="Email"
                    color="primary"
                    variant="outlined"
                    className="input"
                    name="email"
                    value={this.state.email}
                    onChange={this.handleChange}
                    helperText={
                      this.state.error.inputName === "email"
                        ? this.state.error.errorMsg
                        : null
                    }
                    error={this.state.error.inputName === "email"}
                    size="small"
                  ></TextField>
                  <TextField
                    label="Phone Number"
                    color="primary"
                    variant="outlined"
                    type="number"
                    className="input"
                    name="phoneNumber"
                    value={
                      this.state.phoneNumber === 0 ? "" : this.state.phoneNumber
                    }
                    onChange={this.handleChange}
                    helperText={
                      this.state.error.inputName === "phoneNumber"
                        ? this.state.error.errorMsg
                        : null
                    }
                    error={this.state.error.inputName === "phoneNumber"}
                    size="small"
                  ></TextField>
                  <FormControl
                    variant="outlined"
                    size="small"
                    fullWidth
                    className="input"
                  >
                    <InputLabel>Currency</InputLabel>
                    <Select
                      value={this.state.currency}
                      onChange={this.handleChange}
                      name="currency"
                      label="Currency"
                    >
                      <MenuItem value="INR">INR</MenuItem>
                      <MenuItem value="USD">USD</MenuItem>
                    </Select>
                  </FormControl>
                  <TextField
                    label="Amount"
                    color="primary"
                    variant="outlined"
                    className="input"
                    type="number"
                    name="amount"
                    value={this.state.amount === 0 ? "" : this.state.amount}
                    onChange={this.handleChange}
                    helperText={
                      this.state.error.inputName === "amount"
                        ? this.state.error.errorMsg
                        : null
                    }
                    error={this.state.error.inputName === "amount"}
                    size="small"
                  ></TextField>
                </div>
                <Button
                  color="primary"
                  variant="contained"
                  onClick={this.handlePay}
                >
                  Proceed
                </Button>
              </>
            )}
          </div>
        </Modal>
      </>
    );
  }
}
